// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"f0c45ec6","787":"6c45ad4b","967":"cd77777d"}[chunkId] + ".chunk.js";
};